import {mockups} from "../mockups";
import {renderModalContent, showModal} from "../components/helpers";

export function ajaxAddToCart(productData, productType) {
    const AJAX_MODE = 'test';
    const AJAX_URL = AJAX_MODE === 'dev' ? '' : '/ajax/cart/';
    const $cartModal = $('#cart_modal');
    let ajaxData;

    if (productType === 'customShirt') {
        //смотрим - включен ли чекбокс по опциям
        let logosData = [];
        const isOptionsChecked = $('#additional_options').prop('checked');

        if(isOptionsChecked){
            const additionalOptionValue = $('#additional_options').parent().data('logo-id');
            logosData.push(`${additionalOptionValue}`);
        }

        ajaxData = {
            ajaxAction: "add",
            itemId: +productData.itemId,
            sizeId: productData.size,
            count: +productData.count,
            customShirtFamily: productData.customShirtLastName,
            customShirtNumber: productData.customShirtNumber,
            customShirtType: productData.customShirtType,
            options: logosData
        }

    } else {
        ajaxData = {
            ajaxAction: "add",
            itemId: +productData.itemId,
            count: +productData.count
        }

        if(productData?.size && productData?.size !== 0 && productData?.size !== '0'){
            ajaxData.sizeId = productData?.size;
        }
    }

    $.ajax({
        url: `${AJAX_URL}`,
        type: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(ajaxData),
        xhrFields: {
            withCredentials: true
        },
        success: function (data) {
            if (data) {
                successFn(data, productData, productType);

            } else {
                errorFn();
            }
        },
        error: function (data) {
            if (AJAX_MODE === 'dev') {
                data = mockups.addToCart;
                if (data) {
                    successFn(data, productData, productType);

                } else {
                    errorFn();
                }

            } else {
                errorFn();
            }
        },
        timeout: 30000
    });

    function successFn(data, productData, productType) {
        const $cartCountBlockMob = $('[data-cart-count-mob]');
        const $cartCountBlockDesk = $('[data-cart-count-desk]');
        const currentCartCount = +$cartCountBlockMob.text();

        if(!$cartCountBlockMob.length || !$cartCountBlockDesk.length){
            $('.profile-link.cart').append(`<div class="cart-count hide-desktop" data-cart-count-mob>1</div>`);
            $('.profile-link.cart').find('.cart-text').append(`<div class="cart-count" data-cart-count-desk>1</div>`);

        }else{
            $cartCountBlockMob.add($cartCountBlockDesk).text(currentCartCount + 1);
        }

        renderModalContent(data, productData, productType);
        showModal($cartModal);
    }

    function errorFn() {
        console.log('bad')
    }
}